import { produce } from 'immer'
import { useFormikContext } from 'formik'
import { type ChangeEvent, useCallback } from 'react'

import type { CheckedHandler } from '../../typings'
import type { LocAndSvcsFormModel } from '../../formConfig'

export function useActions() {
  const { setValues } = useFormikContext<LocAndSvcsFormModel>()

  const onChange = useCallback<CheckedHandler>(
    (e: ChangeEvent<HTMLInputElement>, checked: boolean) =>
      setValues((values) =>
        produce(values, (draft) => {
          const id = Number(e.target.value)
          draft.serviceIds.set(id, checked)
        }),
      ),
    [setValues],
  )

  return onChange
}
